import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Paper,
} from "@mui/material";
import Header from "../components/UserNavebar";
import Footer from "../components/Footer";
import waves from "../assets/Images/Angled.png";

const SearchResultsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Data received from navigate state
  const filteredRows = location.state?.results || [];

  return (
    <>
      <Header />
      <Box
        sx={{
          backgroundImage: `url(${waves})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          bgcolor: "#f4f6f8",
          minHeight: "70vh",
          p: { xs: 2, md: 4 },
        }}
      >
        <Paper
          elevation={6}
          sx={{
            maxWidth: 1000,
            width: "100%",
            p: { xs: 2, sm: 3, md: 4 },
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            borderRadius: 3,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              textAlign: "center",
              mb: 1,
              fontSize: { xs: "1.3rem", md: "1.8rem" },
            }}
          >
            General Search Results
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              textAlign: "center",
              mb: 3,
              color: "gray",
              fontSize: { xs: "0.85rem", md: "1rem" },
            }}
          >
            Here is the list of individuals that match the searched parameters.
          </Typography>

          <Box sx={{ overflowX: "auto" }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>#</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Full Names</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Date of Birth</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Gender</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Post Code</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Address</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRows.length > 0 ? (
                  filteredRows.map((row, index) => (
                    <TableRow key={row.id || index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.name}</TableCell>
                      <TableCell>{row.dob}</TableCell>
                      <TableCell>{row.gender}</TableCell>
                      <TableCell>{row.postcode}</TableCell>
                      <TableCell>{row.address}</TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: "#a7c957",
                            color: "black",
                            textTransform: "none",
                            fontWeight: "bold",
                            fontSize: { xs: "0.75rem", md: "0.9rem" },
                            px: { xs: 1.5, md: 2 },
                            "&:hover": { backgroundColor: "#8bbf40" },
                          }}
                          onClick={() => {
                            localStorage.setItem("selectedUserData", JSON.stringify(row));
                            navigate("/Profile");
                          }}
                        >
                          View Profile
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No results found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
        </Paper>
      </Box>
      <Footer />
    </>
  );
};

export default SearchResultsPage;
